import {Injectable} from '@angular/core';
import {FlashMessagesService} from 'angular2-flash-messages';
import {URL_API} from "../constante";
import {Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {Trabalho} from "../trabalho/trabalho";
import {Utils} from '../shared/utils';
import {AppService} from "../app.service";

@Injectable()
export class CertificadoService extends AppService {

    getTrabalhos(): Promise<Trabalho[]> {
        return this.http.get(URL_API + '/certificado')
            .toPromise()
            .then(response => response.json() as Trabalho[])
            .catch((error) => this.utils.handleError(error));
    }
	
	exportar(trabalhoId: number): Promise<Response> {
        return this.http.get(URL_API + '/certificado/' + trabalhoId)
            .toPromise()
            .then(response => this.utils.handle(response))
            .catch((error) => this.utils.handleError(error));
    }
}



// WEBPACK FOOTER //
// ./src/app/certificado/certificado.service.ts